import { Dimension } from '../../../../../../common/model/types';
import EnvironmentIconSVG from './environment.svg';
import HealthIconSVG from './health.svg';
import KnowledgeIconSVG from './knowledge.svg';
import SocialIconSVG from './society.svg';

interface Props {
  width?: number;
  height: number;
  color?: string;
  preserveAspectRatio?: string;
}

export function dimensionIconAspectRatio(dimension: Dimension): number {
  switch (dimension) {
    case Dimension.ENVIRONMENT:
      return 12 / 14;
    case Dimension.HEALTH:
      return 13 / 11;
    case Dimension.KNOWLEDGE:
      return 11 / 13;
    case Dimension.SOCIAL:
      // eslint-disable-next-line sonarjs/no-identical-expressions
      return 12 / 12;
  }
}

export const EnvironmentIcon = (props: Props) => (
  <EnvironmentIconSVG {...widthAndHeight(props, Dimension.ENVIRONMENT)} />
);
export const HealthIcon = (props: Props) => <HealthIconSVG {...widthAndHeight(props, Dimension.HEALTH)} />;
export const SocialIcon = (props: Props) => <SocialIconSVG {...widthAndHeight(props, Dimension.SOCIAL)} />;
export const KnowledgeIcon = (props: Props) => <KnowledgeIconSVG {...widthAndHeight(props, Dimension.KNOWLEDGE)} />;

function widthAndHeight(props: Props, dimension: Dimension) {
  const width = props.width ? props.width : props.height * dimensionIconAspectRatio(dimension);
  const height = props.height;
  return {
    width,
    height,
  };
}

export function dimensionIcon(dimension: Dimension) {
  switch (dimension) {
    case Dimension.ENVIRONMENT:
      return EnvironmentIcon;
    case Dimension.HEALTH:
      return HealthIcon;
    case Dimension.KNOWLEDGE:
      return KnowledgeIcon;
    case Dimension.SOCIAL:
      return SocialIcon;
  }
}

export function getDimensionIconSvg(dimension: Dimension) {
  switch (dimension) {
    case Dimension.ENVIRONMENT:
      return EnvironmentIconSVG;
    case Dimension.HEALTH:
      return HealthIconSVG;
    case Dimension.KNOWLEDGE:
      return KnowledgeIconSVG;
    case Dimension.SOCIAL:
      return SocialIconSVG;
  }
}
